<template>
  <div class="content-page">
    <div class="tab-header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>兑换详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="tab-content">
      <el-table :data="userActiveList" style="width: 100%" :max-height="550">
        <el-table-column align="left" prop="openTime" label="活动发起时间" />
        <el-table-column align="center" prop="joinCount" label="参与人数" />
        <el-table-column align="center" prop="priceNow" label="当前价格" />
        <el-table-column align="center" prop="openCount" label="查看次数" />
        <el-table-column align="center" prop="finishTime" label="是否完成">
          <template slot-scope="scope">
            {{ scope.row.finishTime ? "是" : "否" }}
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-show="userActiveList.length > 0" style="padding-left:15px;">
      <el-pagination
        @current-change="handleCurrentChange"
        :page-size="queryInfo.row"
        :current-page="queryInfo.pageNo"
        background
        layout="total, prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { getuserActivityList, getUserActivityListTotalNum } from "../api/index";
export default {
  data() {
    return {
      queryInfo: {
        pageNo: 1,
        row: 10,
      },
      total: 0,
      userActiveList: [],
    };
  },
  mounted() {
    let id = localStorage.activityId;
    this.getuserActivityList(id);
  },
  beforeDestroy() {
    localStorage.removeItem("activityId");
  },
  methods: {
    getuserActivityList(activityId) {
      getuserActivityList({
        activityId: activityId,
        pageNo: this.queryInfo.pageNo,
        row: this.queryInfo.row,
      }).then((res) => {
        getUserActivityListTotalNum({
          activityId: activityId,
          pageNo: this.queryInfo.pageNo,
          row: this.queryInfo.row,
        }).then((res) => {
          if (res.code == 1) {
            this.total = res.data.totalNum;
          } else {
            this.total = 0;
          }
        });
        if (res.code == 1) {
          this.userActiveList = res.data;
        } else if (res.code == -1) {
          this.userActiveList = [];
        } else {
        }
      });
    },
    handleCurrentChange(val) {
      this.queryInfo.pageNo = val;
      this.getuserActivityList();
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  .tab-header {
  }
  .tab-content {
    // width: calc(100vw - 280px);
    padding: 0 15px;
  }
}
</style>
